const AdminCell = require("../../../../../../../dumb/TableHeadCell/AdminCell");
const React = require("react");

module.exports = ({self}) => (
  <div className="w abs bgE layoutRow aiStretch ov">
    <AdminCell className="wmin185 fx1">
      ID
    </AdminCell>
    <AdminCell
      className="wmin185 fx1"
      // sortName="created_at"
      // self={self}
    >
      Date and Time
    </AdminCell>
    <AdminCell className="wmin185 fx1">
      Merchant Name
    </AdminCell>
    <AdminCell className="wmin185 fx1">
      Merchant APP
    </AdminCell>
    <AdminCell className="wmin185 fx1">
      Wallet Address
    </AdminCell>
    <AdminCell
      className="wmin185 fx1"
      // sortName="amount"
      // self={self}
    >
      Amount
    </AdminCell>
    <AdminCell className="wmin185 fx1">
      Hash
    </AdminCell>
    <AdminCell className="wmin185 fx1">
      Status
    </AdminCell>
    <AdminCell className="wmin240">
      Actions
    </AdminCell>
  </div>
)
